import { ColorEnum } from '@/constants/color'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { StyleSheet } from 'react-native'

interface ValidationMessageProps {
    message: string
    status: 'error' | 'success'
}

const ValidationMessage: FC<ValidationMessageProps> = ({ message, status }) => {
    return (
        <Typography.Description
            font="medium"
            size="small"
            style={status === 'success' ? styles.success : styles.error}
        >
            {message}
        </Typography.Description>
    )
}

const styles = StyleSheet.create({
    error: {
        color: ColorEnum.BRICK_500,
        marginTop: 4,
    },
    success: {
        color: ColorEnum.EMERALD_700,
        marginTop: 4,
    },
})

export default ValidationMessage
